document.addEventListener('DOMContentLoaded', function () {
  let display = -1
  let isListenerAdded = false
  const handelLoadMore = e => {
    let column_list
    if (window.innerWidth <= 768) {
        column_list = document.querySelectorAll(
        '.custom-photo-wall_photos_mb_column'
      )
    } else {
      column_list = document.querySelectorAll(
        '.custom-photo-wall_photos_pc_column'
      )
    }

    let photos = Array.from(column_list).map((item, index) => {
      return Array.from(item.children)
    })
    function preventScroll () {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = `${scrollBarWidth}px`
    }
    function allowScroll () {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
    display += 2
    photos.forEach((item, index) => {
      item.forEach((photo, index) => {
        if (!isListenerAdded) {
          photo
            .querySelector('.photo-wall-item-image')
            .addEventListener('click', () => {
              photo.querySelector('.mask').classList.replace('hidden', 'block')
              preventScroll()
            })
          photo.querySelector('.mask').addEventListener('click', e => {
            photo.querySelector('.mask').classList.replace('block', 'hidden')
            allowScroll()
          })
          photo.querySelector('.close').addEventListener('click', e => {
            photo.querySelector('.mask').classList.replace('block', 'hidden')
            allowScroll()
          })
        }
        if (index <= display) {
          photo.children[0].classList.replace('hidden', 'visible')
        }
      })
    })
    if (photos[photos.length - 1].length - 1 <= display) {
      document.querySelector('.load_more').classList.add('hidden')
    }
    isListenerAdded = true
  }
  window.addEventListener('resize', () => {
    if(window.innerWidth <= 768){
        location.reload()
    }
  })
  document.querySelector('.load_more').addEventListener('click', handelLoadMore)
  handelLoadMore()
})
